module.exports = __webpack_public_path__ + "static/img/Xen.0950491.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/team/Xen.png
// module id = 9UYG
// module chunks = 1